import "./TestModal.css";
import classes from "./TestModal.module.css";
import Overview from "../../assets/icon/overview.png";
import Details from "../../assets/icon/details.png";
import Settings from "../../assets/icon/settings.png";
import { Modal } from "react-bootstrap";
import { useState } from "react";
import OverviewPage from "./OverviewPage";
import DetailsPage from "./DetailsPage";
import SettingsPage from "./SettingsPage";

type TestModalProps = {
  showModal: boolean;
  handleCloseModal: () => void;
};

const TestModal: React.FC<TestModalProps> = (props) => {
  const [selectedMenu, setSelectedMenu] = useState(0);

  const handleSelectMenu = (menu: number) => {
    setSelectedMenu(menu);
  };

  return (
    <Modal
      show={props.showModal}
      onHide={props.handleCloseModal}
      dialogClassName="modal-80w modal-90h"
      contentClassName="no-border modal-90h"
      centered
    >
      <Modal.Body className="no-padding">
        <div className={classes["left-content"]}>
          <div className={classes["base-margin"]}>
            <div
              className={`${classes["menu-container"]}  ${
                selectedMenu === 0 ? classes["menu-container-selected"] : ""
              }`}
              onClick={() => {
                handleSelectMenu(0);
              }}
            >
              <img
                src={Overview}
                className={classes["sidemenu-icon"]}
                alt="Overview Icon"
              />
            </div>
            <div
              className={`${classes["menu-container"]}  ${
                selectedMenu === 1 ? classes["menu-container-selected"] : ""
              }`}
              onClick={() => {
                handleSelectMenu(1);
              }}
            >
              <img
                src={Details}
                className={classes["sidemenu-icon"]}
                alt="Details Icon"
              />
            </div>
            <div
              className={`${classes["menu-container"]}  ${
                selectedMenu === 2 ? classes["menu-container-selected"] : ""
              }`}
              onClick={() => {
                handleSelectMenu(2);
              }}
            >
              <img
                src={Settings}
                className={classes["sidemenu-icon"]}
                alt="Settings Icon"
              />
            </div>
          </div>
        </div>
        <div className={classes["right-content"]}>
          {selectedMenu === 0 && (
            <OverviewPage handleCloseModal={props.handleCloseModal} />
          )}
          {selectedMenu === 1 && (
            <DetailsPage handleCloseModal={props.handleCloseModal} />
          )}
          {selectedMenu === 2 && (
            <SettingsPage handleCloseModal={props.handleCloseModal} />
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TestModal;
